export const AlignHorizontalLeft = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="1" height="16" fill="currentColor"></rect>
    <rect width="1" height="16"></rect>
    <rect x="4" y="2" width="12" height="5" rx="1.5" fill="currentColor"></rect>
    <rect x="4" y="2" width="12" height="5" rx="1.5"></rect>
    <rect x="4" y="9" width="6" height="5" rx="1.5" fill="currentColor"></rect>
    <rect x="4" y="9" width="6" height="5" rx="1.5"></rect>
  </svg>
);

export const AlignHorizontalCenter = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="7" width="1" height="16" fill="currentColor"></rect>
    <rect x="7" width="1" height="16"></rect>
    <rect y="2" width="15" height="5" rx="1.5" fill="currentColor"></rect>
    <rect y="2" width="15" height="5" rx="1.5"></rect>
    <rect x="4" y="9" width="7" height="5" rx="1.5" fill="currentColor"></rect>
    <rect x="4" y="9" width="7" height="5" rx="1.5"></rect>
  </svg>
);

export const AlignHorizontalRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="1"
      height="16"
      transform="matrix(-1 0 0 1 16 0)"
      fill="currentColor"
    ></rect>
    <rect width="1" height="16" transform="matrix(-1 0 0 1 16 0)"></rect>
    <rect
      width="12"
      height="5"
      rx="1.5"
      transform="matrix(-1 0 0 1 12 2)"
      fill="currentColor"
    ></rect>
    <rect
      width="12"
      height="5"
      rx="1.5"
      transform="matrix(-1 0 0 1 12 2)"
    ></rect>
    <rect
      width="7"
      height="5"
      rx="1.5"
      transform="matrix(-1 0 0 1 12 9)"
      fill="currentColor"
    ></rect>
    <rect
      width="7"
      height="5"
      rx="1.5"
      transform="matrix(-1 0 0 1 12 9)"
    ></rect>
  </svg>
);

export const AlignVerticalTop = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="1"
      height="16"
      transform="matrix(0 1 1 0 0 0)"
      fill="currentColor"
    ></rect>
    <rect width="1" height="16" transform="matrix(0 1 1 0 0 0)"></rect>
    <rect
      width="12"
      height="5"
      rx="1.5"
      transform="matrix(0 1 1 0 2 4)"
      fill="currentColor"
    ></rect>
    <rect width="12" height="5" rx="1.5" transform="matrix(0 1 1 0 2 4)"></rect>
    <rect
      width="7"
      height="5"
      rx="1.5"
      transform="matrix(0 1 1 0 9 4)"
      fill="currentColor"
    ></rect>
    <rect width="7" height="5" rx="1.5" transform="matrix(0 1 1 0 9 4)"></rect>
  </svg>
);

export const AlignVerticalCenter = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4121_5437)">
      <path d="M0 8L0 7L16 7V8L0 8Z" fill="currentColor"></path>
      <path
        d="M3.50001 15C2.67158 15 2 14.3284 2 13.5L2.00001 1.5C2.00001 0.671572 2.67158 -9.53674e-07 3.50001 -9.53674e-07H5.5C6.32843 -9.53674e-07 7 0.671572 7 1.5L7 13.5C7 14.3284 6.32843 15 5.50001 15L3.50001 15Z"
        fill="currentColor"
      ></path>
      <path
        d="M10.5 12C9.67157 12 9 11.3284 9 10.5L9 4.5C9 3.67157 9.67158 3 10.5 3H12.5C13.3284 3 14 3.67157 14 4.5V10.5C14 11.3284 13.3284 12 12.5 12L10.5 12Z"
        fill="currentColor"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4121_5437">
        <rect
          width="15"
          height="16"
          fill="white"
          transform="translate(0 15) rotate(-90)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
);

export const AlignVerticalBottom = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4121_5417)">
      <rect
        y="16"
        width="1"
        height="16"
        transform="rotate(-90 0 16)"
        fill="currentColor"
      ></rect>
      <rect y="16" width="1" height="16" transform="rotate(-90 0 16)"></rect>
      <rect
        x="2"
        y="12"
        width="12"
        height="5"
        rx="1.5"
        transform="rotate(-90 2 12)"
        fill="currentColor"
      ></rect>
      <rect
        x="2"
        y="12"
        width="12"
        height="5"
        rx="1.5"
        transform="rotate(-90 2 12)"
      ></rect>
      <rect
        x="9"
        y="12"
        width="7"
        height="5"
        rx="1.5"
        transform="rotate(-90 9 12)"
        fill="currentColor"
      ></rect>
      <rect
        x="9"
        y="12"
        width="7"
        height="5"
        rx="1.5"
        transform="rotate(-90 9 12)"
      ></rect>
    </g>
    <defs>
      <clipPath id="clip0_4121_5417">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 16) rotate(-90)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
);
